import { gql } from '@apollo/client';
import { USER_FRAGMENT } from '../user/user.gql';

export const AVAILABLE_WORKERS_FOR_JOB_QUERY = gql`
  query GetUsersAvailableForJob($jobId: String!) {
    getUsersAvailableForJob(jobId: $jobId) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const AVAILABLE_WORKERS_FOR_JOB_CRITERIA_QUERY = gql`
  query GetUsersAvailableForJobCriteria(
    $classificationId: String!
    $clientId: String!
    $startDate: String!
    $endDate: String!
    $lat: Float
    $lng: Float
  ) {
    getUsersAvailableForJobCriteria(
      classificationId: $classificationId
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
      lat: $lat
      lng: $lng
    ) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
